module.exports = __webpack_public_path__ + "JayJainAward-c4c73e9f.webp";